import { render, staticRenderFns } from "./RecommendedCourses.html?vue&type=template&id=5ca5bf2c&scoped=true&external"
import script from "./RecommendedCourses.vue?vue&type=script&lang=js"
export * from "./RecommendedCourses.vue?vue&type=script&lang=js"
import style0 from "./RecommendedCourses.scss?vue&type=style&index=0&id=5ca5bf2c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5bf2c",
  null
  
)

export default component.exports